import EventPost from 'flarum/forum/components/EventPost';
import Link from 'flarum/common/components/Link';
export default class DiscussionSplit extends EventPost {
  /**
   * Get the name of the event icon.
   *
   * @return {String}
   */
  icon() {
    return 'fas fa-code-branch';
  }

  /**
   * Get the translation key for the description of the event.
   *
   * @return {String}
   */
  descriptionKey() {
    const content = this.attrs.post.content();
    if (content['toNew']) {
      return 'fof-split.forum.post.was_split_to';
    }
    return 'fof-split.forum.post.was_split_from';
  }

  /**
   * Get the translation data for the description of the event.
   *
   * @return {Object}
   */
  descriptionData() {
    const content = this.attrs.post.content();
    return {
      count: content['count'],
      target: m(Link, {
        className: "EventPost-Split-target",
        href: content['url']
      }, content['title'])
    };
  }
}
flarum.reg.add('fof-split', 'forum/components/DiscussionSplit', DiscussionSplit);